import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function ItemCategoryMaster(props) {
  const [itemCategories, setItemCategories] = useState([]);
  const [ItemCategoryCode, setItemCategoryCode] = useState('');
  const [itemCategoryName, setItemCategoryName] = useState('');
  const [itemCategoryNameEng, setItemCategoryNameEng] = useState('');
  const [itemSubGroupCode, setItemSubGroupCode] = useState('');
  const [itemSubGroupName, setItemSubGroupName] = useState('');
  
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  
  const [formMode, setFormMode] = useState('add');
  const [editItemCategoryId, setEditItemCategoryId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [itemCategoryMasterEntries, setItemCategoryMasterEntries] = useState([]);
  const [ItemSubGroup, setItemSubGroup] = useState([]);


  useEffect(() => {
    fetchItemCategoryMaster();
    fetchItemSubGroup();
  }, []);

  const fetchItemCategoryMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/itemcategories');
      setItemCategoryMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;  
      setItemCategoryCode(nextEntryNo);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };

  
  const calculateMaxEntryNo = (entries) => {
  let maxEntryNo = 0;
  for (const entry of entries) {
  if (entry.ItemCategoryCode > maxEntryNo) {
    maxEntryNo = entry.ItemCategoryCode;
  }
  }
  return maxEntryNo;
  };

  const fetchItemSubGroup = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/itemsubgroups');
      setItemSubGroup(response.data);
      //console.log('SubLedger:', response.data);
    } catch (error) {
      console.log('Error fetching AcGroups:', error);
    }
  };

  const addItemCategory = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/itemcategories', {
        ItemCategoryCode: ItemCategoryCode,
        ItemCategoryName: itemCategoryName,
        ItemCategoryNameEng: itemCategoryNameEng,
        ItemSubGroupCode: itemSubGroupCode,
        USERID: props.name
      });
      fetchItemCategoryMaster();
      setItemCategoryCode('');
      setItemCategoryName('');
      setItemCategoryNameEng('');
      setItemSubGroupCode('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateItemCategory = async (ItemCategoryCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/itemcategories/${ItemCategoryCode}`, {
        ItemCategoryCode: ItemCategoryCode,
        ItemCategoryName: itemCategoryName,
        ItemCategoryNameEng: itemCategoryNameEng,
        ItemSubGroupCode: itemSubGroupCode,
        USERID: props.name
      });
      fetchItemCategoryMaster();
      setItemCategoryCode('');
      setItemCategoryName('');
      setItemCategoryNameEng('');
      setItemSubGroupCode('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteItemCategory = async (ItemCategoryCode) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/itemcategories/${ItemCategoryCode}`, {
        headers: {
          'username': props.name,
        },
      });

      if (response.status === 200) {
        fetchItemCategoryMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  }; 

  const setEditForm = (itemCategory) => {
    setFormMode('edit');
    setItemCategoryCode(itemCategory.ItemCategoryCode);
    setItemCategoryName(itemCategory.ItemCategoryName);
    setItemCategoryNameEng(itemCategory.ItemCategoryNameEng);
    setItemSubGroupCode(itemCategory.ItemSubGroupCode);
    setShowGrid(false);
    const selectedGroup = ItemSubGroup.find(group => group.ItemSubGroupCode === itemCategory.ItemSubGroupCode);
    if (selectedGroup) {
      setItemSubGroupName(selectedGroup.ItemSubGroupName);
    }
  };

  const handleSearch = (searchQuery) => {
    const filtered = itemCategories.filter((itemCategory) => {
      const ItemCategoryCode = itemCategory.ItemCategoryCode.toString().toLowerCase();
      const ItemCategoryName = itemCategory.ItemCategoryName.toString().toLowerCase();
      const ItemCategoryNameEng = itemCategory.ItemCategoryNameEng.toString().toLowerCase();
      const ItemSubGroupCode = itemCategory.ItemSubGroupCode.toString().toLowerCase();

      return (
        ItemCategoryCode.includes(searchQuery.toLowerCase()) ||
        ItemCategoryName.includes(searchQuery.toLowerCase()) ||
        ItemCategoryNameEng.includes(searchQuery.toLowerCase()) ||
        ItemSubGroupCode.includes(searchQuery.toLowerCase())
      );
    });

    setItemCategoryMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, itemCategories]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setItemCategories(itemCategories);
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditItemCategoryId('');
    setItemCategoryCode('');
    setItemCategoryName('');
    setItemCategoryNameEng('');
    setItemSubGroupCode('');
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "ItemCategoryData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>ItemCategoryMaster</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="ItemCategoryCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>ItemCategoryCode</label>
            <input
              type="text"
              value={ItemCategoryCode}
              readOnly
              placeholder="ItemCategoryCode"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="itemCategoryName" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>ItemCategoryName</label>
            <input
              type="text"
              value={itemCategoryName}
              onChange={(e) => setItemCategoryName(e.target.value)}
              placeholder="ItemCategoryName"
              style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="itemCategoryNameEng" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>ItemCategoryNameEng</label>
            <input
              type="text"
              value={itemCategoryNameEng}
              onChange={(e) => setItemCategoryNameEng(e.target.value)}
              placeholder="ItemCategoryNameEng"
              style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
          <label htmlFor="itemSubGroupName" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>ItemSubGroupName</label>
            <select
              value={itemSubGroupName}
              onChange={(e) => {
                const selectedGroupName = e.target.value;
                setItemSubGroupName(selectedGroupName);
                const selectedGroup = ItemSubGroup.find(group => group.ItemSubGroupName === selectedGroupName);
                if (selectedGroup) {
                  setItemSubGroupCode(selectedGroup.ItemSubGroupCode);
                }
              }}
              style={{ marginBottom: '5px', padding: '5px', width: '20%' }}
            >
              {ItemSubGroup.map((group) => (
                <option key={group.ItemSubGroupCode} value={group.ItemSubGroupName}>{group.ItemSubGroupName}</option>
              ))}
            </select>
            <input
              type="text"
              value={itemSubGroupCode}
              readOnly
              placeholder="ItemSubGroupCode"
              style={{ marginLeft:'10px',marginBottom: '5px', padding: '5px', width: '12%' }}
            />
          </div>
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addItemCategory : () => updateItemCategory(ItemCategoryCode)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
      </>      
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ItemCategoryCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ItemCategoryName
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ItemCategoryNameEng
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  ItemSubGroupCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {itemCategoryMasterEntries.map((itemCategory) => (
                <tr key={itemCategory.ItemCategoryCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{itemCategory.ItemCategoryCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{itemCategory.ItemCategoryName}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{itemCategory.ItemCategoryNameEng}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{itemCategory.ItemSubGroupCode}</td>
                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(itemCategory)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => deleteItemCategory(itemCategory.ItemCategoryCode)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default ItemCategoryMaster;
